// CandidateImageSignature_new.jsx (src/views/home/CandidateImageSignature_new.jsx). Migration target
// namespace referenced in modules/i18n/dictionary.js's "Additional namespaces" comment. Consumed via
// key path "imageSignature.xxx" by that file's <Text k="imageSignature.xxx"/> / tr("imageSignature.xxx")
// calls (Stage 3.9 Phase E migration pass — see src/views/NewLogin.jsx for the same idiom).
//
// All entries below except the 4 upload-success notification messages were already bilingual in the
// source file — extraction only, zero new translation authored for those. The 4 *UploadSuccess /
// allUploadsSuccess entries had no existing Marathi anywhere in the file (they were English-only
// _notification.showMessage('success', '...') literals) — Marathi is AI-authored, matching this file's
// own existing terminology (फोटो/स्वाक्षरी/आधार कार्ड/अपलोड करा/यशस्वीरित्या — the last borrowed from
// modules/i18n.js's own "यशस्वीरित्या" usage), NOT reviewed by a native/certified translator; needs
// linguistic QA before production release, same disclosure as dictionary.js's passwordCommon namespace.
export default {
  pageHeading: { en: 'Upload Candidate Image and Signature', mr: 'उमेदवाराचा फोटो आणि स्वाक्षरी अपलोड करा' },

  candidateImageUploadHeader: { en: 'Candidate Image Upload', mr: 'उमेदवाराचा फोटो अपलोड करा' },
  candidateSignatureUploadHeader: { en: 'Candidate Signature Upload', mr: 'उमेदवाराची स्वाक्षरी अपलोड करा' },
  candidateAadhaarUploadHeader: { en: 'Candidate Aadhaar Upload', mr: 'उमेदवाराचे आधार कार्ड अपलोड करा' },

  // Candidate Image Upload card instructions
  imageInstruction1: { en: 'Photograph must be a recent passport style colour picture.', mr: 'पासपोर्ट आकाराचा अलीकडील काळातील रंगीत फोटो असणे आवश्यक आहे' },
  imageInstruction2: {
    en: 'Make sure that the picture is in colour, taken against a light-coloured, preferably white, background.',
    mr: 'शक्यतो हलक्या रंगाच्या पांढऱ्या पार्श्वभुमीसह घेतलेले रंगीत फोटो असल्याची खात्री करा.'
  },
  imageInstruction3: {
    en: "Caps, hats and dark glasses are not acceptable. Religious headwear is allowed but it must not cover your face.",
    mr: 'कॅप्स, टोपी आणि गडद चष्मा स्वीकार्य नाहीत. धार्मिक हेडवेअरला परवानगी आहे पण आपला चेहरा झाकून ठेवू नये.'
  },
  // Shared verbatim between the Candidate Image Upload and Candidate Signature Upload cards in the
  // source file (identical en + mr text in both <ol> lists) — deduplicated to one key.
  sizeLessThan1MB: { en: 'Size of image should be less than 1MB.', mr: 'फोटोचा आकार 1MB पेक्षा कमी असावा.' },
  imageScanInstruction: {
    en: 'Ensure that the size of the scanned image is not more than 1MB. If the size of the file is more than 1MB, then adjust the settings of the scanner such as the DPI resolution, no. of colours etc., during the process of scanning.',
    mr: 'स्कॅन केलेल्या फोटोचा आकार 1MB पेक्षा जास्त नसल्याची खात्री करा. जर फाइलचा आकार 1MB पेक्षा जास्त असेल, तर स्कॅनिंग प्रक्रियेदरम्यान स्कॅनरची सेटिंग्ज समायोजित करा जसे की DPI रिझोल्यूशन, रंगांची संख्या इ.'
  },
  imageFormatInstruction: {
    en: 'The applicant can upload JPG/JPEG/PNG format files only for Image/Photo upload.',
    mr: 'अर्जदार फक्त प्रतिमा/छायाचित्र अपलोड करण्यासाठी JPG/JPEG/PNG फॉरमॅट फाइल्स अपलोड करू शकतो.'
  },
  uploadCandidateImage: { en: 'Upload Candidate Image', mr: 'उमेदवाराचा फोटो अपलोड करा' },

  // Candidate Signature Upload card instructions
  signatureInstruction1: { en: 'The applicant has to sign on white paper with Black Ink/jel pen.', mr: 'अर्जदाराने काळ्या शाई/जेल पेनने पांढऱ्या कागदावर सही करावी.' },
  signatureInstruction2: {
    en: 'The signature must be signed only by the applicant and not by any other person.',
    mr: 'स्वाक्षरी फक्त अर्जदाराची असणे आवश्यक आहे आणि इतर कोणत्याही व्यक्तीची नाही.'
  },
  signatureInstruction3: {
    en: 'The signature will be used to put on the Hall Ticket, attendance sheet and wherever necessary.',
    mr: 'सहीचा उपयोग हॉल तिकीट, हजेरी पत्रक आणि आवश्यक त्या ठिकाणी लावण्यासाठी केला जाईल.'
  },
  signatureInstruction4: {
    en: "If the Applicant's signature on the answer script, at the time of the examination, does not match the signature on the Hall Ticket, the applicant will be disqualified.",
    mr: 'परीक्षेच्या वेळी उत्तरपत्रिकेवरील अर्जदाराची स्वाक्षरी, हॉल तिकिटावरील स्वाक्षरीशी जुळत नसल्यास अर्जदारास अपात्र घोषित केले जाईल.'
  },
  signatureDimensions: { en: 'Dimensions 3.5 cm x 1.5cm (preferred)', mr: 'परिमाण 3.5 सेमी x 1.5 सेमी (प्राधान्य)' },
  signatureScanInstruction: { en: 'Ensure that the size of the scanned image is not more than 1MB.', mr: 'स्कॅन केलेल्या फोटोचा आकार 1MB पेक्षा जास्त नसल्याची खात्री करा.' },
  signatureFormatInstruction: {
    en: 'The applicant can upload JPG/JPEG/PNG format files only for Signature upload.',
    mr: 'अर्जदार फक्त स्वाक्षरी अपलोडसाठी JPG/JPEG/PNG फॉरमॅट फाइल्स अपलोड करू शकतो.'
  },
  uploadCandidateSignature: { en: 'Upload Candidate Signature', mr: 'उमेदवाराची स्वाक्षरी अपलोड करा' },

  // Candidate Aadhaar Upload card instructions
  aadhaarFormatInstruction: {
    en: 'The applicant can upload JPG/JPEG/PNG/PDF format files only for Aadhaar upload.',
    mr: 'अर्जदार आधार अपलोडसाठी फक्त JPG/JPEG/PNG/PDF फॉरमॅट फाइल अपलोड करू शकतो.'
  },
  aadhaarSizeInstruction: { en: 'Size of Image/PDF should be less than 1MB.', mr: 'फोटो/पीडीएफचा आकार 1MB पेक्षा कमी असावा.' },
  uploadCandidateAadhaar: { en: 'Upload Candidate Aadhaar Card', mr: 'उमेदवाराचे आधार कार्ड अपलोड करा' },

  // Footer buttons
  cancelButton: { en: 'Cancel', mr: 'रद्द करा' },
  previousButton: { en: 'Previous', mr: 'मागे' },
  saveAndNext: { en: 'Save & Next', mr: 'जतन करा आणि पुढे जा' },

  // Upload-success notifications (_notification.showMessage('success', ...)) — English-only in the
  // source file, no existing Marathi. AI-authored, needs linguistic QA.
  profileImageUploadSuccess: { en: 'Profile Image uploaded successfully.', mr: 'प्रोफाइल फोटो यशस्वीरित्या अपलोड झाला.' }, // AI-authored, needs linguistic QA
  signatureUploadSuccess: { en: 'Signature uploaded successfully.', mr: 'स्वाक्षरी यशस्वीरित्या अपलोड झाली.' }, // AI-authored, needs linguistic QA
  aadhaarUploadSuccess: { en: 'Aadhaar uploaded successfully.', mr: 'आधार यशस्वीरित्या अपलोड झाले.' }, // AI-authored, needs linguistic QA
  allUploadsSuccess: {
    en: 'Candidate image, signature & aadhaar uploaded successfully.',
    mr: 'उमेदवाराचा फोटो, स्वाक्षरी आणि आधार यशस्वीरित्या अपलोड करण्यात आले.'
  } // AI-authored, needs linguistic QA
};
